import { render, staticRenderFns } from "./BowContent2Cols.vue?vue&type=template&id=647ab0ee&"
import script from "./BowContent2Cols.vue?vue&type=script&lang=js&"
export * from "./BowContent2Cols.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BowHeading: require('/workspace/components/atoms/BowHeading/BowHeading.vue').default,BowText: require('/workspace/components/atoms/BowText/BowText.vue').default,BowCallToAction: require('/workspace/components/molecules/BowCallToAction/BowCallToAction.vue').default,BowWrapper: require('/workspace/components/base/BowWrapper/BowWrapper.vue').default})
